/** @jsx jsx */
import { useMemo } from 'react';
import { jsx } from '@emotion/core';
import { N80, N900 } from '@atlaskit/theme/colors';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
var fontFamily = getFontFamily();
export var labelCSS = function labelCSS() {
  return {
    fontFamily: fontFamily,
    alignItems: 'center',
    display: 'flex',
    color: N900,
    cursor: 'default',
    '&[data-disabled]': {
      color: N80,
      cursor: 'not-allowed'
    }
  };
};
export default function Label(_ref) {
  var children = _ref.children,
      isDisabled = _ref.isDisabled,
      testId = _ref.testId;
  var styles = useMemo(function () {
    return labelCSS();
  }, []);
  return (// https://product-fabric.atlassian.net/browse/DST-1973
    // eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for
    jsx("label", {
      css: styles,
      "data-testid": testId,
      "data-disabled": isDisabled || undefined
    }, children)
  );
}